import { useIntl } from '@leagueplatform/locales';
import { Link, LocalesKey } from 'common/types';
import { createLink } from 'utils/navigation-links.utils';
import { useAccountSettingLinks } from './use-account-setting-links.hook';
import { useSupportLinks } from './use-support-links.hook';

export interface DropdownSection {
  heading?: string;
  items: Link[];
}

export type Options = {
  heading?: LocalesKey;
  items: Link[];
};

export function useUserDropdownConfig(
  handleDeleteAccount: () => void,
): DropdownSection[] {
  const { formatMessage } = useIntl();
  const accountSettingLinks = useAccountSettingLinks();
  const supportLinks = useSupportLinks();

  const privacyAndLegalLinks: Link[] = [
    'privacyPolicy',
    'privacyNotices',
    'privacyForms',
    'hippaNotice',
    'grammLeach',
    'nondiscrimination',
    'washingtonPrivacy',
    'appeals',
    'grievances',
    'disclaimers',
  ].map((type) => createLink(type as any, formatMessage));

  const aboutLinks: Link[] = [
    createLink('aboutCigna', formatMessage),
    createLink('languageAssistance', formatMessage),
    createLink('privacyPolicy', formatMessage),
    createLink('termsOfUse', formatMessage),
    createLink('deleteAccount', formatMessage, handleDeleteAccount),
  ];

  return [
    {
      heading: formatMessage({ id: 'STR_ACCOUNT_SETTINGS' }),
      items: accountSettingLinks,
    },
    {
      heading: formatMessage({ id: 'STR_SUPPORT' }),
      items: supportLinks,
    },
    {
      heading: formatMessage({ id: 'STR_PRIVACY_AND_LEGAL_DOCUMENTS' }),
      items: privacyAndLegalLinks,
    },
    {
      heading: formatMessage({ id: 'STR_ABOUT' }),
      items: aboutLinks,
    },
    {
      items: [createLink('logOut', formatMessage)],
    },
  ];
}
